import loadable from '@loadable/component';
import './UserRating.css';

export default loadable(() => {
  return import('./UserRating.jsx');
});
